import addMinutes from 'date-fns/addMinutes';
import {isAfter as isDateAfter, isBefore as isDateBefore,startOfDay} from 'date-fns';
import { convertDateTimeToTimeString, getMinutesfromTimeString, getUTCDate } from "../dataGrid/gridUtilities";
import appConstant from "../../../src/appConstants";
import { getPendingStopStatus } from '../modules/Dispatch/utils/utils';
export default class CheckViolation{
    static checkAppointmentMissed = (params) => {
        const statusValueGetter = params.api.getColumnDef('stopStatus') && params.api.getColumnDef('stopStatus').valueGetter;
        if(statusValueGetter && statusValueGetter(params) === appConstant.STOP_STATUS.DELAYED){
            return 'Driver expected to arrive late at customer location';
        }
    }

    static checkPrepTimeGreaterThanStartTime = (params) => {
        const { stopPrepTime, routeStartTime } = params.data;
        const { planDate } = params;
        const [stopDate, stopTime] = stopPrepTime ? stopPrepTime.split(" ") : [null, null];

        if(stopPrepTime && planDate && !isDateBefore(stopDate, planDate) && (isDateAfter(stopDate, planDate) || CheckViolation.isTimeAfter(stopTime, routeStartTime))){
            return appConstant.VIOLATION_MESSAGES.LATE_PROS;
        }
    }

    static checkLoadCloseTimeGreaterThanStartTime = (params) => {
        const { loadCloseTime, startTime } = params.data;
        if(CheckViolation.isTimeAfter(loadCloseTime, startTime)){
            return appConstant.VIOLATION_MESSAGES.LATE_PROS;
        }
    }

    static checkNumServiceViolation = (params) => {
        const { numServiceViolations } = params.data;
        if(numServiceViolations){
            return `${numServiceViolations} missed appointment${numServiceViolations > 1 ? 's':''}`;
        }
    }

    static checkLocationGeoCoded = (params) => {
      const { isGeoCoded } = params.data.deliveryDetails;
      if(isGeoCoded === false){
        return "Geocoding Required";
      }
    }

    static checkClosedCustomerViolation = ({isCustomerClosed}) => {
      if(isCustomerClosed){
        return "Customer is closed today";
      }
    }

    static checkClosedCustomerViolationForRouteStops = ({isCustomerClosed}) => {
      if(isCustomerClosed){
        return "One or more customers are closed today";
      }
    }

    static checkTrailerLiftGateViolation = (params) => {
        const { lgProCount, trailerName } = params.data;
        const { trailersData } =  params.context || {};
        if(lgProCount && trailerName && trailersData && trailersData.length > 0){
            const trailer = trailersData.find((trailer) => trailer.trailerName === trailerName);
            if(trailer && !trailer.isLiftGateRequired){
                return 'Route needs a Liftgate trailer';
            }
        }
    }

    static checkRouteStartTimeViolation = (params) => {
        const { shipmentEtaDateTime,  preparationTime, routeStartTime } = params.data;
        const { planDate }= params;
        if(shipmentEtaDateTime && routeStartTime) {
            const UtcFormatTime = getUTCDate(shipmentEtaDateTime);
            const updatedTime = addMinutes(UtcFormatTime, preparationTime);
            if(planDate && !isDateBefore(startOfDay(updatedTime), planDate) && (isDateAfter(startOfDay(updatedTime), planDate) || CheckViolation.isTimeAfter(`${updatedTime.getHours()}:${updatedTime.getMinutes()}`, routeStartTime))){
              return 'Pro arriving too late for route start time';
            }
        }
    }
    //check if the first time after the second one.
    static isTimeAfter = (time, comparisonTime) => {
        return time && comparisonTime && getMinutesfromTimeString(time) > getMinutesfromTimeString(comparisonTime);
    }

    static checkNewProsInRoute = (params) => {
        const {data} = params;
        const { newShipments } = params.context || {};
        const newProsCount = newShipments && newShipments.data && newShipments.data.filter(pro => pro.routeName && pro.routeName !== appConstant.UNRTD_ROUTENAME && pro.routeName === data.routeName).length;
        return newProsCount ? `${newProsCount} New pro(s) added` : null;
    }

    static checkProIsNew = (params) => {
        const {data} = params;
        const { newShipments } =  params.context || {};
        const isNewPro = newShipments && newShipments.data && newShipments.data.some(pro => pro.proId === data.proId && pro.routeName === data.routeName);
        return isNewPro ? 'New pro' : null
    }

    static checkNewProsInStop = (params) => {
        const {data} = params;
        const { newShipments } =  params.context || {};
        const newProsCount = newShipments && newShipments.data && newShipments.data.filter(pro => pro.routeStopId === data.routeStopId && pro.routeName === data.routeName).length;
        return newProsCount ? `${newProsCount} New pro(s) added` : null;
    }

    static checkDriverHasDelayStops = (params) => {
        const { stops } = params.data;
        const hasDelayStops = stops?.some(
          (stop) =>
            !stop.isStopCompleted &&
            getPendingStopStatus(stop) === appConstant.STOP_STATUS.DELAYED
        );
        return hasDelayStops ? 'Driver expected to arrive late at customer location': null;
    };

    static checkEquipmentMatch = (params)=> {
        if (params.context?.hasEquipmentMismatch?.(params.data)) {
            return "Customer equipment preference mismatch";
        }
        return null;
    }

    static checkIBETATimeGreaterThanDockCutOffTime = (params,dockCutoffTime) => {
        if(!params.data.actualArrivalTime && params.data.shipmentEtaDateTime){
            const IBETATime = convertDateTimeToTimeString(params.data.shipmentEtaDateTime);
            return IBETATime > dockCutoffTime
              ? "Shipment is arriving after the dock cutoff time"
              : null;
        }
        return null;
    }

    static getRouteViolationsFromEngine = (params) => {
        const { violations } = params.data;
        return violations ? violations.map((violation) => violation.message) : [];
    }
}